// client/src/components/auth/ForgotPassword.js
import React, { useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';
import api from '../../services/api';
import { AuthBackground, generateParticles } from './Login';
import './Login.css';

const inputStyle = {
  width: '100%',
  padding: '12px 14px',
  borderRadius: '10px',
  border: '1px solid rgba(255,255,255,0.18)',
  background: 'rgba(255,255,255,0.06)',
  color: '#fff',
  fontSize: '0.95rem',
  outline: 'none',
  boxSizing: 'border-box',
};

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const particles = useMemo(() => generateParticles(20), []);
  const mazeRef = useRef(null);
  const particlesRef = useRef(null);

  const submit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      await api.auth.forgotPassword(email.trim());
    } catch (_) {
      /* always generic */
    }
    setSubmitting(false);
    setDone(true);
  };

  return (
    <div className="login-page">
      <AuthBackground particles={particles} mazeRef={mazeRef} particlesRef={particlesRef} />
      <div className="login-card" style={{ opacity: 1, transform: 'none' }}>
        <div className="login-logo">
          <span className="login-wordmark" role="img" aria-label="LexiBridge">
            <span className="lw-lexi">Lexi</span>
            <span className="lw-divider" />
            <span className="lw-bridge">Bridge</span>
          </span>
        </div>
        <h2 className="login-welcome">Reset your password</h2>

        {done ? (
          <>
            <p className="login-prompt">
              If an account exists for that email, a reset link has been sent. Please check your
              inbox.
            </p>
            <button className="login-button" onClick={() => navigate('/login')}>
              <ArrowLeft size={18} /> Back to sign in
            </button>
          </>
        ) : (
          <form
            onSubmit={submit}
            style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}
          >
            <p className="login-prompt">
              Enter your email and we&apos;ll send you a link to set a new password.
            </p>
            <input
              type="email"
              placeholder="Email"
              value={email}
              autoComplete="username"
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={submitting}
              style={inputStyle}
            />
            <button type="submit" className="login-button" disabled={submitting}>
              <Mail size={18} /> {submitting ? 'Sending…' : 'Send reset link'}
            </button>
            <p style={{ textAlign: 'center', marginTop: 8, fontSize: '0.85rem' }}>
              <a href="/login" style={{ color: '#45B7AA', textDecoration: 'none' }}>
                Back to sign in
              </a>
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
